// extracted by mini-css-extract-plugin
export default {"itemWrapper":"Shortcut_itemWrapper__wBwjI","shortcutImg":"Shortcut_shortcutImg__28Pch"};